import React from 'react';
import './index.css';

const PostCard = ({ title, date, tags, excerpt }) => {
  return (
    <div className="post-card">
      <div className="post-header">
        <h3>{title}</h3>
        <span className="post-date">{date}</span>
      </div>
      <p className="post-excerpt">{excerpt}</p>
      <div className="post-tags">
        {tags.map((tag, idx) => (
          <span key={idx} className="tag">{tag}</span>
        ))}
      </div>
      <button className="btn-purple read-more">阅读更多</button>
    </div>
  );
};

export default PostCard;